import logDevServiceWorkerMessage from 'dev/service-worker-interop/logDevServiceWorkerMessage';
import * as ToastActions from 'nav/toasts/ToastActions';
import {ToastType} from 'nav/toasts/ToastConstants';

export function notifyForError(errorMessage: string): void {
  logDevServiceWorkerMessage(`Error: ${errorMessage}`);
  ToastActions.pushToast({
    type: ToastType.WARNING,
    message: errorMessage,
    actionText: 'Reload',
    duration: 0,
    onActionClick(): void {
      window.location.reload();
    },
  });
}
